import type React from 'react';

import { DeleteVariantIcon } from '@vlabs/icons';
import { Control } from '@vlabs/uikit';
import type { WithDataTestid } from '@vlabs/uikit/types';
import { useTranslation } from 'react-i18next';

import st from './DeleteFaceConfirmation.module.sass';

interface DeleteFaceConfirmationProps extends WithDataTestid {
  onConfirm: VoidFunction;
  onReject: VoidFunction;
}

function DeleteFaceConfirmation({
  onConfirm,
  onReject,
  'data-testid': dataTestId = undefined,
}: DeleteFaceConfirmationProps): React.JSX.Element {
  const { t } = useTranslation();
  return (
    <div
      className={st.DeleteFaceConfirmation}
      data-testid={dataTestId}
    >
      <div className={st.Header}>
        <DeleteVariantIcon className={st.Icon} />
        <div className={st.Description}>
          <span className={st.Title}>{t('features:deleteFace.confirmation.title')}</span>
          <span className={st.Subtitle}>{t('features:deleteFace.confirmation.subtitle')}</span>
        </div>
      </div>

      <div className={st.Actions}>
        <Control.Button
          className={st.Action}
          kind="secondary"
          onClick={onReject}
          variant="outlined"
        >
          {t('features:deleteFace.btn.cancel')}
        </Control.Button>
        <Control.Button
          className={st.Action}
          kind="negative"
          onClick={onConfirm}
          variant="filled"
        >
          {t('features:deleteFace.btn.delete')}
        </Control.Button>
      </div>
    </div>
  );
}

export { DeleteFaceConfirmation };
